(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService', 'AlertToastService'];

    function notificationInterceptor($q, AlertService, AlertToastService) {
        var service = {
            response: response
        };

        return service;

        function response(response) {

            var alertKey = response.headers('X-tikonApp-alert');

            if (angular.isString(alertKey)) {
                // AlertService.success(alertKey, { param : response.headers('X-tikonApp-params')});
                AlertToastService.success(alertKey, {param: response.headers('X-tikonApp-params')});
            }
            return response;
        }
    }
})();
